import { useQuery } from '@tanstack/react-query';
import { profilesApi } from '@/api';

export const useGetAvailableLangs = () => {
    return useQuery({
        queryKey: ['available-langs'],
        queryFn: () => profilesApi.getAvailableLangs(),
    });
};
